<template>
  <div class="application-detail">
    <!-- 基本类型 -->
    <base-info :baseInfo="baseInfo" :type="type" />
    <!-- 担保申请 -->
    <a-card title="担保申请" style="margin:10px 0px;">
      <a-form-model ref="ruleForm" inline :model="guaForm" :rules="rules">
        <a-row :gutter="40">
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="文件编号">
              <a-input
                v-model="guaForm.code"
                style="width: 100%"
                allowClear
                :disabled="disabled"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="文件名称">
              <a-input
                v-model="guaForm.fileName"
                style="width: 100%"
                allowClear
                :disabled="disabled"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="担保-保证书类型" prop="bookType">
              <a-select
                v-model="guaForm.bookType"
                placeholder="请选择"
                style="width: 275px"
                allowClear
                @change="hangleChange"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="担保方名称" prop="assuranceName">
              <a-input
                v-model="guaForm.assuranceName"
                style="width: 100%"
                allowClear
                :disabled="disabled"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <template v-if="[1].includes(guaForm.bookType)">
            <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
              <a-form-model-item label="担保个人身份" prop="identity">
                <a-select
                  v-model="guaForm.identity"
                  placeholder="请选择"
                  style="width: 275px"
                  allowClear
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in personList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </template>
          <template v-if="[2, 3].includes(guaForm.bookType)">
            <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
              <a-form-model-item label="上市公司" prop="isListed">
                <a-select
                  v-model="guaForm.isListed"
                  placeholder="请选择"
                  style="width: 275px"
                  allowClear
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in YSList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
              <a-form-model-item label="上市公司担保公告" prop="assureNotice">
                <a-select
                  v-model="guaForm.assureNotice"
                  placeholder="请选择"
                  style="width: 275px"
                  allowClear
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in YSList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </template>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="书面担保金额" prop="writtenAmount">
              <a-input
                v-model="guaForm.writtenAmount"
                style="width: 100%"
                allowClear
                :disabled="disabled"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="有效担保金额" prop="validAmount">
              <a-input
                v-model="guaForm.validAmount"
                style="width: 100%"
                allowClear
                :disabled="disabled"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <!-- 担保生效日期 -->
            <a-form-model-item label="担保生效日期" prop="efficientDate">
              <a-date-picker
                v-model="guaForm.efficientDate"
                placeholder="请选择日期"
                style="width: 100%;"
                allowClear
                format="YYYY-MM-DD"
                :disabled="disabled"
              />
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="担保到期日期" prop="expireDate">
              <a-date-picker
                v-model="guaForm.expireDate"
                style="width: 100%"
                format="YYYY-MM-DD"
                placeholder="请选择日期"
                allowClear
                :disabled="disabled"
              />
            </a-form-model-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
            <a-form-model-item label="货币" prop="currencyUnit">
              <a-select
                v-model="guaForm.currencyUnit"
                placeholder="请选择"
                style="width: 275px"
                allowClear
                :disabled="disabled"
              >
                <a-select-option :value="1">
                  RMB
                </a-select-option>
                <a-select-option :value="2">
                  USD
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <!-- 申请原因及备注 -->
      <div class="apply-reason-memo" style="margin:20px 0;">
        <div class="ant-descriptions-title">申请原因及备注</div>
        <quill-editor :token="token" ref="quillEditor"></quill-editor>
        <affix ref="affix" style="margin-top: 20px;" :maxSize="30"></affix>
      </div>
    </a-card>
    <!-- 提交 -->
    <footer-tool-bar>
      <a-button @click="goBack" style="margin:0px 20px;">取消</a-button>
      <a-button type="primary" @click="handleSubmit" :loading="loading">
        提交申请
      </a-button>
    </footer-tool-bar>
    <!-- 增加审批人 -->
    <a-card title="增加审批人" style="margin:10px 0px;">
      <multi-select-approval ref="multiSelectApproval" :list="approvePersons" />
    </a-card>

    <a-card>
      <a-checkbox @change="onChange">
        已检查符合担保要求
      </a-checkbox>
    </a-card>
    <a-modal
      :visible="showModal"
      :width="1200"
      @ok="handleOk"
      okText="失效"
      :ok-button-props="{ props: { disabled: disabledbtn } }"
      @cancel="handleCancel"
    >
      <a-table
        :row-selection="rowSelection"
        :columns="columns"
        :data-source="data"
        row-key="id"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import MultiSelectApproval from './components/MultiSelectApproval.vue'
import { ERR_OK } from 'config/index'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
import {
  queryBase,
  getAssurancePersons,
  IsListAssurance,
  addAssurance,
} from './api'
import QuillEditor from '../../credit-approval/components/QuillEditor.vue'
import Affix from './components/Affix.vue'
import moment from 'moment'
const columns = [
  {
    title: '担保方名称',
    dataIndex: 'assuranceName',
  },
  {
    title: '担保书类型',
    dataIndex: 'bookTypeStr',
  },
  {
    title: '文件编号',
    dataIndex: 'code',
  },
  {
    title: '文件名称',
    dataIndex: 'fileName',
  },
  {
    title: '书面担保金额',
    dataIndex: 'writtenAmount',
  },
  {
    title: '有效担保额度',
    dataIndex: 'validAmount',
  },
  {
    title: '货币',
    dataIndex: 'currencyUnitStr',
  },
  {
    title: '担保生效日期',
    dataIndex: 'efficientDate',
  },
  {
    title: '担保到期日期',
    dataIndex: 'expireDate',
  },
]
const formatAmount = num => {
  return numeral(num).format('0,0.00')
}
export default {
  data() {
    //这里存放数据
    return {
      companyCode: '',
      columns,
      type: '',
      checked: false,
      showModal: false,
      showvisible: false,
      disabledbtn: true,
      message: '',
      approvePersons: [], // 审批人列表
      loading: false,
      baseInfo: {},
      disabled: false,
      rules: {
        bookType: [
          {
            required: true,
            message: '请输入担保-保证书类型',
            trigger: 'blur',
          },
        ],
        assuranceName: [
          {
            required: true,
            message: '请输入担保方名称',
            trigger: 'change',
          },
        ],
        identity: [
          { required: true, message: '请输入担保个人身份', trigger: 'change' },
        ],
        isListed: [
          {
            required: true,
            message: '请输入上市公司',
            trigger: 'change',
          },
        ],
        assureNotice: [
          {
            required: true,
            message: '请输入上市公司担保公告',
            trigger: 'change',
          },
        ],
        writtenAmount: [
          {
            required: true,
            message: '请输入书面担保金额',
            trigger: 'blur',
          },
        ],
        validAmount: [
          {
            required: true,
            message: '请输入有效担保金额',
            trigger: 'blur',
          },
        ],
        efficientDate: [
          {
            required: true,
            message: '请输入担保生效日期',
            trigger: 'change',
          },
        ],
        expireDate: [
          {
            required: true,
            message: '请输入担保到期日期',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: '请输入货币',
            trigger: 'blur',
          },
        ],
      },
      YSList: [
        {
          value: 1,
          name: '是',
        },
        {
          value: 2,
          name: '否',
        },
      ],
      personList: [
        {
          value: 1,
          name: '法人',
        },
        {
          value: 2,
          name: '实际控制人',
        },
        {
          value: 3,
          name: '大股东',
        },
        {
          value: 4,
          name: '其他',
        },
      ],
      statusList: [
        {
          value: 1,
          name: '个人担保',
        },
        {
          value: 2,
          name: '第三方公司担保',
        },
        {
          value: 3,
          name: '关联公司互保',
        },
      ],
      data: [],
      managerList: [],
      checkApprovalPerson: [],
      ids: [],
      formatAmount,
      guaForm: {
        currencyUnit: '',
        expireDate: '',
        efficientDate: '',
        validAmount: '',
        writtenAmount: '',
        fileName: '',
        isListed: '',
        remark: '',
        identity: '',
        assureNotice: '',
        assuranceName: '',
        bookType: '',
        code: '',
      },
    }
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`${selectedRowKeys}`)
          if (selectedRows.length) {
            this.disabledbtn = false
            selectedRows.map(item => {
              this.ids.includes(item.id)
                ? this.ids.splice(1)
                : this.ids.push(item.id)
            })
          } else {
            this.disabledbtn = true
            this.ids = []
          }
        },
      }
    },
    ...mapGetters('user', ['token']),
  },
  components: {
    BaseInfo,
    QuillEditor,
    Affix,
    FooterToolBar,
    MultiSelectApproval,
  },
  //方法集合
  methods: {
    hangleChange(value) {
      if (value == 1) {
        this.guaForm.isListed = ''
        this.guaForm.assureNotice = ''
      } else if (value == 2 || value == 3) {
        this.guaForm.identity = ''
      }
    },
    async handleOk() {
      this._getShowTableData()
      this.showModal = false
    },
    async handleCancel() {
      this.showModal = false
      this.checkApprovalPerson = this.$refs.multiSelectApproval.validate()
      if (!this.checkApprovalPerson) {
        return false
      }
      try {
        const query = {
          approvePerson: this.checkApprovalPerson.approvePersons,
          ...this.guaForm,
          type: this.type,
          ids: [],
          isDisable: 2,
          companyCode: this.companyCode,
          applyRemark: this.$refs.quillEditor.getContent(),
          attachmentIds: this.$refs.affix.getAttachmentIds(),
        }
        const { code } = await addAssurance(query)
        if (code == ERR_OK) {
          this.$message.success('成功')
          this.$router.push('/Item/guarantee-detail/approve')
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async _getShowTableData() {
      try {
        this.checkApprovalPerson = this.$refs.multiSelectApproval.validate()
        if (!this.checkApprovalPerson) {
          return false
        }
        const query = {
          approvePerson: this.checkApprovalPerson.approvePersons,
          ...this.guaForm,
          type: this.type,
          isDisable: this.ids.length ? 1 : 2,
          ids: this.ids,
          companyCode: this.companyCode,
          applyRemark: this.$refs.quillEditor.getContent(),
          attachmentIds: this.$refs.affix.getAttachmentIds(),
        }
        const { code, message } = await addAssurance(query)
        if (code == '0000' && message == '成功') {
          this.$message.success('成功')
          this.$router.push('/Item/guarantee-detail/approve')
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    onChange(e) {
      this.checked = `${e.target.checked}`
    },
    async _getApprovePersons() {
      try {
        const { data } = await getAssurancePersons()
        this.approvePersons = data
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    async handleSubmit() {
      this.loading = true
      try {
        const valid = await this.$refs.ruleForm.validate()
        if (this.checked) {
          const attachmentIds = this.$refs.affix.getAttachmentIds()
          if (valid && attachmentIds.length) {
            const assuranceName = this.guaForm.assuranceName
            const companyId = this.baseInfo.companyId
            const bookType = this.guaForm.bookType
            const { data } = await IsListAssurance({
              companyId,
              bookType,
              assuranceName,
            })
            if (data.length) {
              this.showModal = true
              this.data = data
              this.data.map(item => {
                item.efficientDate = moment(item.efficientDate).format(
                  'YYYY-MM-DD',
                )
                item.expireDate = moment(item.expireDate).format('YYYY-MM-DD')
                item.validAmount = this.formatAmount(item.validAmount)
                item.writtenAmount = this.formatAmount(item.writtenAmount)
              })
            } else {
              this._getShowTableData()
            }
            this.loading = false
          } else {
            this.loading = false
            this.$message.error('请上传附件')
          }
        } else {
          this.loading = false
          this.$message.error('请勾选已检查符合担保要求')
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async getBaseInfo(companyCode) {
      try {
        const { data } = await queryBase(companyCode)
        this.baseInfo = data
      } catch (error) {
        console.log(error)
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.type = this.$route.query.type
    this.companyCode = this.$route.params.companyCode
    this.getBaseInfo(this.companyCode)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getApprovePersons()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
